<template>
  <div class="drawer-wrapper">
    <el-drawer size="50%" title="查看" :wrapperClosable="true" :visible.sync="innerVisible" :before-close="handleClose">

      <div class="demo-drawer__content">
        <el-form :model="obj" size="medium" label-width="75px" class="mt35" ref="ruleForm">
          <el-row :gutter="35" class="center-content">
            <el-col :xs="24" :sm="12" :md="8" :lg="15" :xl="20" class="mb20">
              <el-form-item label="小说名称" prop="owner">
                <el-input v-model="obj.movie_name" placeholder="请输入负责人" :disabled="isDisabled"></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="8" :lg="15" :xl="20" class="mb20">
              <el-form-item label="剧集ID" prop="owner">
                <el-input v-model="obj.episodes_id" placeholder="请输入负责人" clearable :disabled="isDisabled"></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="8" :lg="15" :xl="20" class="mb20">
              <el-form-item label="章节名称" prop="owner">
                <el-input v-model="obj.episodes_name" placeholder="请输入负责人" clearable :disabled="isDisabled"></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="8" :lg="15" :xl="20" class="mb20">
              <el-form-item label="剧集序号" prop="owner">
                <el-input v-model="obj.episodes_idx" placeholder="请输入负责人" clearable :disabled="isDisabled"></el-input>
              </el-form-item>
            </el-col>
            <!-- <el-col :xs="24" :sm="12" :md="8" :lg="15" :xl="20" class="mb20">
              <el-form-item label="充值模版" prop="recharge_template_id">
                <el-select v-model="obj.recharge_template_id" placeholder="请选择充值模版" clearable
                           class="w100" :disabled="isDisabled">
                  <el-option v-for="dict in Recharge" :key="dict.id" :label="dict.value"
                             :value="dict.id"/>
                </el-select>
              </el-form-item>
            </el-col> -->
            <el-col :xs="24" :sm="12" :md="8" :lg="15" :xl="20" class="mb20">
              <el-form-item label="小说平台" prop="platform_type">
                <el-select v-model="obj.platform_type" placeholder="请选择小说平台" clearable class="w100"
                           :disabled="isDisabled">
                  <el-option label="抖音" value="1"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="8" :lg="15" :xl="20" class="mb20">
              <el-form-item label="投放媒体" prop="media">
                <el-select v-model="obj.media" placeholder="请选择投放媒体" clearable class="w100" :disabled="isDisabled">
                  <el-option v-for="dict in Placement" :key="dict.name" :label="dict.name"
                             :value="dict.key"/>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="8" :lg="15" :xl="20" class="mb20">
              <el-form-item label="媒体前缀" prop="channel_prefix">
                <el-input v-model="obj.channel_prefix" placeholder="" clearable :disabled="isDisabled"></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="8" :lg="15" :xl="20" class="mb20">
              <el-form-item label="推广链接名称">
                <el-input v-model="obj.channel_name" placeholder="请输入推广链接名称" clearable :disabled="isDisabled"></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="8" :lg="15" :xl="20" class="mb20">
              <el-form-item label="推广链接个数">
                <el-input v-model="obj.channel_num" placeholder="请输入推广链接个数" clearable :disabled="isDisabled"></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="8" :lg="15" :xl="20" class="mb20">
              <el-form-item label="状态" prop="status">
                <el-radio-group v-model="obj.status" :disabled="isDisabled">
                  <el-radio :label="1">有效</el-radio>
                  <el-radio :label="3">停止投放</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="8" :lg="15" :xl="20" class="mb20">
              <el-form-item label="负责人" prop="owner">
                <el-input v-model="obj.owner" placeholder="请输入负责人" clearable :disabled="isDisabled"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>

      <div class="demo-drawer__footer">
        <el-button @click="handleClose">取 消</el-button>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import {channelNumberAPI} from '@/api/popularize/channelNumber';

export default {
  props: ['innerVisible', 'id'],
  name: '',
  components: {},
  data() {
    return {
      obj: {},
      Recharge: [],
      Placement: [],
      isDisabled: true
    };
  },
  created() {
  },
  mounted() {
    let api = channelNumberAPI()
    api.detailsList(this.id).then(res => {
      if (res.code == 0) {
        // this.obj = res.data
        this.obj={...res.data,platform_type:res.data.platform_type==1?'抖音':'微信'}
      }
    })
  },
  methods: {
    handleClose() {
      this.$emit('noneDlg')
    }
  },
};
</script>
<style scoped lang="scss">
.Box {
  & ::v-deep el-card__body {
    padding: 0 !important;
  }
}

.center-content {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}

.center-content .el-col {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.demo-drawer__content {
  overflow-y: auto; /* 添加垂直滚动条 */
  overflow-x: hidden;
}

.demo-drawer__footer {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 10px;
  text-align: center;
}

.demo-drawer__footer .el-button {
  //flex: 1; /* 让按钮平分容器宽度 */
  width: 320px; /* 设置按钮宽度为120px */
}

::v-deep .el-drawer__close-btn{
  font-size: 30px;
  font-weight: bold;
}
</style>
